import * as z from "zod";

export const StaticTableArtifact_ = z.object({
  title: z.string().optional(),
  headers: z.array(z.string()),
  rows: z.array(z.array(z.string())),
});
export type StaticTableArtifact = z.infer<typeof StaticTableArtifact_>;

export const ChartValueFormat_ = z.enum([
  "number",
  "integer",
  "currency",
  "percent",
]);
export type ChartValueFormat = z.infer<typeof ChartValueFormat_>;

export const ChartAxisType_ = z.enum(["category", "time", "number"]);
export type ChartAxisType = z.infer<typeof ChartAxisType_>;

const ChartAxis_ = z.object({
  label: z.string().optional(),
  type: ChartAxisType_.optional(),
});

const ChartValueAxis_ = z.object({
  label: z.string().optional(),
  format: ChartValueFormat_.optional(),
});

const ChartPoint_ = z.object({
  x: z.union([z.string(), z.number()]),
  y: z.number(),
});

const ChartSeries_ = z.object({
  name: z.string(),
  points: z.array(ChartPoint_),
});

export const ChartArtifact_ = z.object({
  schemaVersion: z.literal(1),
  title: z.string().optional(),
  subtitle: z.string().optional(),
  chartType: z.enum([
    "line",
    "bar",
    "stacked_bar",
    "horizontal_bar",
    "pie",
    "scatter",
  ]),
  xAxis: ChartAxis_.optional(),
  yAxis: ChartValueAxis_.optional(),
  series: z.array(ChartSeries_).min(1),
  options: z
    .object({
      showLegend: z.boolean().optional(),
      showPoints: z.boolean().optional(),
    })
    .optional(),
});
export type ChartArtifact = z.infer<typeof ChartArtifact_>;
